import { Trans } from "@lingui/macro";
import { GoogleDriveIcon } from "@src/components/ui-kit/Icon";
import { ButtonLink, type ButtonLinkProps } from "@src/components/ui-kit/Link";
import { useStore } from "@src/utils/hooks";
import type { FC } from "react";

type GoogleDriveLinkProps = Omit<ButtonLinkProps, "isExternal"> & {
  href: string;
};

export const GoogleDriveLink: FC<GoogleDriveLinkProps> = (props) => {
  const { authStore } = useStore();
  if (!authStore.isInternalUser) return null;
  return (
    <ButtonLink
      leftIcon={<GoogleDriveIcon w="5" h="5" />}
      isExternal
      {...props}
      variant="outline"
      colorScheme="grey"
      size="sm"
    >
      <Trans>Open in google drive</Trans>
    </ButtonLink>
  );
};
